<!--
 * @Author: Wang hui
 * @Date: 2021-04-30 14:25:01
 * @LastEditTime: 2021-05-07 15:12:33
 * @LastEditors: Please set LastEditors
 * @Description: 首页
 * @FilePath: \Wjb-Website\src\views\home\home.vue
-->
<template>
  <div>
    <div ref="NavHeight" @click="clear">
      <div class="header" ref="HeaderTopHeight">
        <div class="nav">
          <div class="nav-tab">
            <div
              class="tab-one"
              @click.stop="active(item, 1)"
              v-for="(item, index) in tabs"
              :key="index"
            >
              <div>
                <p
                  :class="
                    actives == item.active
                      ? `tab-name tab-name-active`
                      : `tab-name`
                  "
                >
                  {{ item.name }}
                </p>
                <div class="tab-line" v-show="actives == item.active"></div>
              </div>
            </div>
            <div class="cod-flag" v-show="codFlag">
              <img src="@/assets/images/home/nav/hover-cod.png" alt="" />
            </div>
          </div>
          <div class="nav-list" @click="pop()">
            <img src="@/assets/images/home/nav/nav-list.png" alt="" />
          </div>
          <div class="nav-img" @click="top">
            <img src="@/assets/images/home/nav/logo.png" alt="" />
          </div>
        </div>
        <div class="header-left">
          <div class="header-left-title">首创全球性跨界消费分期云服务平台</div>
          <div class="header-left-mes">让每个人的生活变得更好</div>
        </div>
        <div class="header-right">
          <img src="@/assets/images/home/header/bg-qiu.png" alt="" />
        </div>
      </div>
      <div class="cover">
        <p>无尽宝·只还本的分期购物</p>
        <div class="mes">
          无尽宝免息分期平台隶属于必尔诺（上海）科技服务有限公司，是全场景信用卡消费与免息分期平台，旨在通过0利息0手续费的支付方式为消费者实现轻松消费，并与银行共同为商户获取优质流量，提供多方共赢。
        </div>
      </div>

      <div class="main" ref="MainTopHeight">
        <div class="title">布局中国·打造信用分期综合化场景平台独角兽</div>
        <div class="main-one-a">
          <div class="one-a-left">
            <div class="one-line"></div>
            <div class="one-name">TO 银行</div>
            <div class="one-mes">
              为银行信用卡消费搭建统一的分期免息消费场景，协助各银行提高信用卡消费分期资产数量。<br />
              通过线上线下搭建商品及服务多行业、多场景的综合服务商业平台。满足银行业未来信用消费资产类业务的增长需求。
            </div>
          </div>
          <div class="one-a-right">
            <img src="@/assets/images/home/main/bank.png" alt="" />
          </div>
        </div>
        <div class="main-one-b">
          <div class="one-b-left">
            <img src="@/assets/images/home/main/shop.png" alt="" />
          </div>
          <div class="one-b-right">
            <div class="one-line"></div>
            <div class="one-name">TO 商家</div>
            <div class="one-mes">
              为商家提供消费分期服务，<br />
              从线上搭建、线下对接、平台甄选、APP端口接入等方式，进行消费分期直接支付，<br />
              获得优质客户流量，扩大商业经营。
            </div>
          </div>
        </div>
        <div class="main-one-a">
          <div class="one-a-left">
            <div class="one-line"></div>
            <div class="one-name">TO 代理商</div>
            <div class="one-mes">
              通过线上代理品牌入驻，线下代理商户入驻模式， 达到多方共赢的目的。
            </div>
          </div>
          <div class="one-a-right">
            <img src="@/assets/images/home/main/agent.png" alt="" />
          </div>
        </div>
        <div class="main-one-b">
          <div class="one-b-left">
            <img src="@/assets/images/home/main/user.png" alt="" />
          </div>
          <div class="one-b-right">
            <div class="one-line"></div>
            <div class="one-name">TO 用户</div>
            <div class="one-mes">
              0息0费的模式为个人缓解经济压力，<br />
              享受信用卡优惠权益，提升个人信誉、额度。<br />
              生活更便捷，消费更灵活。
            </div>
          </div>
        </div>
      </div>

      <div class="bottom-top">
        <div class="title">跨界分期·开启智慧购物新时代</div>
        <div class="mes">
          <div class="mes-left">
            <div class="mes-line"></div>
            <div class="mes-mes">
              无尽宝与银行共同打造信用消费市场，互惠共赢，通过线上、线下结合的方式为客户提供包含生活服务、在线购物、旅游出行、医疗健康、教育培训、汽车养护等多维度、多场景、组合式免息分期服务。
            </div>
          </div>
          <div class="mes-right">
            <img src="@/assets/images/home/bottomtop/phone-cover.png" alt="" />
          </div>
        </div>
      </div>
      <div class="bottom-bank" ref="BottomTopHeight">
        <div class="title">中国信用卡免息分期消费第一品牌</div>
      </div>
      <div class="bottom-bot" ref="BotTopHeight">
        <div class="bot-left">
          <div class="bot-title">促进业务增长，突破经营瓶颈</div>
          <div class="bot-mes">无尽宝助您一臂之力</div>
          <div class="bot-box">
            <div class="box-one">
              <img
                src="@/assets/images/home/bottom/icon/cooperation.png"
                alt=""
              />
              <p>商务合作：韦经理weicy@wujinbao.net</p>
            </div>
            <div class="box-one">
              <img src="@/assets/images/home/bottom/icon/add.png" alt="" />
              <p>加入我们：辛经理xinqs@wujinbao.net</p>
            </div>
            <div class="box-one">
              <img src="@/assets/images/home/bottom/icon/phone.png" alt="" />
              <p>客服电话：400-007-3203</p>
            </div>
            <div class="box-one">
              <img src="@/assets/images/home/bottom/icon/address.png" alt="" />
              <p>总部地址：上海浦东新区峨山路91弄28号-陆家嘴软件园3号7层</p>
            </div>
          </div>
        </div>
        <div class="bot-right">
          <img src="@/assets/images/home/bottom/wxcod.png" alt="" />
          <p>关注我们</p>
        </div>
      </div>
      <div class="bottom-end">
        Copyright©2021-2031 无尽宝科技服务有限公司 版权所有 ICP证：<a href="https://beian.miit.gov.cn/" target="_blank" style="color:#FFFFFF">辽ICP备18014232号-3</a>
      </div>
    </div>
    <van-popup
      v-model="show"
      position="left"
      :style="{ width: `30%`, height: '100%' }"
    >
      <div class="pop-list">
        <div
          class="tab-one"
          @click.stop="active(item, 2)"
          v-for="(item, index) in tabs"
          :key="index"
        >
          <div>
            <p
              :class="
                actives == item.active ? `tab-name tab-name-active` : `tab-name`
              "
            >
              {{ item.name }}
              <span>></span>
            </p>
          </div>
        </div>
      </div>
    </van-popup>
    <van-popup v-model="showCod" round>
      <div class="hover-cods">
        <img src="@/assets/images/home/nav/hover-cods.png" alt="" />
      </div>
    </van-popup>
  </div>
</template>

<script>
import Vue from "vue";
import { Popup } from "vant";
Vue.use(Popup);
export default {
  name: "home",
  data() {
    return {
      // 最新选中的TAB
      actives: 0,
      codFlag: false,
      tabs: [
        {
          name: `关于我们`,
          active: 0,
        },
        {
          name: `业务内容`,
          active: 1,
        },
        {
          name: `合作伙伴`,
          active: 2,
        },
        {
          name: `联系我们`,
          active: 3,
        },
        {
          name: `下载APP`,
          active: 4,
        },
      ],
      screenWidth: document.body.clientWidth,
      show: false,
      showCod: false,
    };
  },

  methods: {
    // 导航点击
    active(item, type) {
      this.show = false;
      this.actives = item.active;
      this.codFlag = false;
      if (this.actives == 0) {
        document.documentElement.scrollTop = document.body.scrollTop =
          this.$refs.HeaderTopHeight.offsetTop - 50;
      } else if (this.actives == 1) {
        document.documentElement.scrollTop = document.body.scrollTop =
          this.$refs.MainTopHeight.offsetTop - 50;
      } else if (this.actives == 2) {
        document.documentElement.scrollTop = document.body.scrollTop =
          this.$refs.BottomTopHeight.offsetTop - 50;
      } else if (this.actives == 3) {
        document.documentElement.scrollTop = document.body.scrollTop =
          this.$refs.BotTopHeight.offsetTop - 50;
      } else if (this.actives == 4) {
        this.codFlag = true;
      }
      if (this.actives == 4 && type == 2) {
        this.showCod = true;
      }
    },
    top() {
      document.documentElement.scrollTop = document.body.scrollTop = 0;
    },
    clear() {
      this.codFlag = false;
    },
    pop() {
      this.show = !this.show;
    },
  },
  watch: {
    screenWidth(val) {
      this.$store.commit("common/CHANGE_WIDTH", val);
    },
  },
  created() {},
  mounted() {
    //   监听浏览器返回事件
    window.addEventListener("scroll", this.handleScroll);
    const that = this;
    window.addEventListener("resize", function () {
      return (() => {
        window.screenWidth = document.body.clientWidth;
        that.screenWidth = window.screenWidth;
      })();
    });
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>

<style lang='less' scoped>
@media (max-width: 767px) {
  .pop-list {
    padding-top: 255px;
    padding-left: 83px;
    .tab-one {
      margin-top: 130px;
      .tab-name {
        font-size: 75px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #1c1c1c;
      }
    }
  }
  .hover-cods {
    width: 900px;
    height: 900px;
    img {
      display: block;
      width: 900px;
      height: 900px;
    }
  }
  .header {
    // display: flex;
    // justify-content: center;
    // align-items: flex-start;
    position: relative;
    height: 1205px;
    padding-top: 255px;
    padding-left: 130px;
    background: url(../../assets/images/home/header/bg.jpg) no-repeat;
    background-size: cover;
    background-position: center;
    .nav {
      display: flex;
      justify-content: space-between;
      align-items: center;
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      width: 100%;
      height: 255px;
      background: #1c1c1c;
      z-index: 3000;
      .cod-flag {
        position: absolute;
        top: 67px;
        left: 682px;
        img {
          width: 200px;
          height: 200px;
        }
      }
      .nav-tab {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin-left: 359px;
        display: none;

        .tab-one {
          position: relative;
          margin-right: 44px;
          cursor: pointer;
          .tab-name {
            font-size: 14px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #999;
          }
          .tab-name-active {
            color: #fff;
          }
          .tab-line {
            position: absolute;
            top: 130%;
            left: 50%;
            transform: translate(-50%, 0%);
            width: 40px;
            height: 2px;
            background: #0ebcf2;
            margin: 0 auto;
          }
        }
      }
      .nav-list {
        margin-left: 86px;
        width: 110px;
        height: 78px;
        img {
          display: block;
          width: 110px;
          height: 78px;
        }
      }
      .nav-img {
        margin-right: 86px;
        width: 125px;
        height: 175px;
        img {
          display: block;
          width: 125px;
          height: 175px;
        }
      }
    }
    .header-left {
      margin-top: 243px;
      .header-left-title {
        width: 1379px;
        font-size: 125px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #ffffff;
      }
      .header-left-mes {
        font-size: 70px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #ffffff;
        margin-top: 70px;
      }
    }
    .header-right {
      position: absolute;
      bottom: 180px;
      right: 32px;
      width: 745px;
      height: 593px;
      img {
        display: block;
        width: 745px;
        height: 593px;
      }
    }
  }
  .cover {
    position: relative;
    overflow: hidden;
    width: 1765px;
    height: 953px;
    box-shadow: 0px 6px 24px 0px rgba(120, 120, 120, 0.46);
    border-radius: 25px;
    background: url(../../assets/images/home/cover/mes.png) no-repeat;
    background-size: cover;
    background-position: center;
    margin: 0 auto;
    margin-top: -160px;
    p {
      text-align: center;
      font-size: 75px;
      font-family: Source Han Sans CN;
      font-weight: 700;
      color: #333333;
      margin-top: 144px;
    }
    .mes {
      width: 1555px;
      font-size: 60px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #333333;
      line-height: 120px;
      text-align: center;
      margin: 0 auto;
      margin-top: 120px;
    }
  }
  .main {
    overflow: hidden;
    .title {
      font-size: 73px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      color: #333333;
      text-align: center;
      margin-top: 190px;
      margin-bottom: 190px;
    }
    .main-one-a {
      //   overflow: hidden;
      position: relative;
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 1650px;
      height: 1500px;
      margin: 0 auto;
      margin-top: 73px;
      margin-bottom: 153px;

      .one-a-left {
        .one-line {
          width: 182px;
          height: 23px;
          background: #16387e;
        }
        .one-name {
          font-size: 75px;
          font-family: Source Han Sans CN;
          font-weight: 500;
          color: #333333;
          margin-top: 18px;
        }
        .one-mes {
          width: 1650px;
          font-size: 60px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #666666;
          line-height: 120px;
          margin-top: 898px;
        }
      }
      .one-a-right {
        position: absolute;
        top: 44%;
        left: 50%;
        transform: translate(-50%, -50%);
        img {
          width: 720px;
        }
      }
    }

    .main-one-b {
      position: relative;
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 1650px;
      height: 1500px;
      margin: 0 auto;
      margin-top: 73px;
      margin-bottom: 153px;
      .one-b-left {
        position: absolute;
        top: 44%;
        left: 50%;
        transform: translate(-50%, -50%);
        img {
          width: 720px;
        }
      }
      .one-b-right {
        .one-line {
          width: 182px;
          height: 23px;
          background: #16387e;
        }
        .one-name {
          font-size: 75px;
          font-family: Source Han Sans CN;
          font-weight: 500;
          color: #333333;
          margin-top: 18px;
        }
        .one-mes {
          width: 1650px;
          font-size: 60px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #666666;
          line-height: 120px;
          margin-top: 898px;
        }
      }
    }
  }
  .bottom-top {
    position: relative;
    overflow: hidden;
    height: 2175px;
    background: url(../../assets/images/home/bottomtop/bpttom-top-bg.jpg)
      no-repeat;
    background-size: cover;
    background-position: -1350px;
    .title {
      margin-top: 182px;
      font-size: 80px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      color: #ffffff;
      text-align: center;
      margin-bottom: 74px;
    }
    .mes {
      width: 1620px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 0 auto;
      margin-top: 1250px;
      .mes-left {
        .mes-line {
          width: 110px;
          height: 19px;
          background: #fdfcf7;
        }
        .mes-mes {
          font-size: 60px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #ffffff;
          line-height: 120px;
          margin-top: 42px;
        }
      }
      .mes-right {
        position: absolute;
        top: 44%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 1385px;
        height: 1100px;
        img {
          width: 1385px;
          height: 1100px;
        }
      }
    }
  }
  .bottom-bank {
    height: 1500px;
    background: url(../../assets/images/home/bottom/we-bank.jpg) no-repeat;
    background-size: 160%;
    background-position: center;
    overflow: hidden;
    .title {
      font-size: 80px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      color: #333;
      text-align: center;
      margin-top: 180px;
      margin-bottom: 150px;
    }
    //   .bottom-img {
    //     // img {
    //     // }
    //   }
  }
  .bottom-bot {
    overflow: hidden;
    height: 1850px;
    background: url(../../assets/images/home/bottom/bottom-bg.jpg) no-repeat;
    background-size: cover;
    background-position: center;
    .bot-left {
      margin-top: 205px;
      .bot-title {
        font-size: 90px;
        font-family: Source Han Sans CN;
        font-weight: 600;
        color: #ffffff;
        margin-left: 123px;
      }
      .bot-mes {
        font-size: 90px;
        font-family: Source Han Sans CN;
        font-weight: 200;
        color: #ffffff;
        margin-top: 62px;
        margin-left: 123px;
      }
      .bot-box {
        margin-top: 95px;
        margin-left: 73px;
        .box-one {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          margin-bottom: 20px;

          img {
            display: block;
            width: 60px;
            height: 55px;
          }
          p {
            margin-left: 13px;
            font-size: 60px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #ffffff;
          }
          &:nth-child(4) {
            img {
              width: 42.5px;
              margin: 0 6px;
            }
          }
        }
      }
    }
    .bot-right {
        width: 520px;
        margin: 0 auto;
        margin-top: 100px;
      img {
        width: 520px;
      }
      p {
        font-size: 60px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #ffffff;
        line-height: 48px;
        letter-spacing: 16px;
        text-align: center;
        margin-top: 20px;
      }
    }
  }
  .bottom-end {
    height: 250px;
    background: #1c1c1c;
    text-align: center;
    line-height: 250px;
    font-size: 60px;
    font-family: Myriad Pro;
    font-weight: 400;
    color: #ffffff;
    a {
      color: #FFFFFF;
    }
  }
}

@media (min-width: 768px) {
  .header {
    display: flex;
    justify-content: center;
    align-items: flex-start;
    width: 1920px;
    height: 800px;
    background: url(../../assets/images/home/header/bg.jpg) no-repeat;
    background-size: 100%;
    .nav {
      display: flex;
      justify-content: space-between;
      align-items: center;
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      width: 1920px;
      height: 91px;
      background: #1c1c1c;
      .cod-flag {
        position: absolute;
        top: 67px;
        left: 682px;
        img {
          width: 200px;
          height: 200px;
        }
      }
      .nav-tab {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin-left: 359px;
        .tab-one {
          position: relative;
          margin-right: 44px;
          cursor: pointer;
          .tab-name {
            font-size: 14px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #999;
          }
          .tab-name-active {
            color: #fff;
          }
          .tab-line {
            position: absolute;
            top: 130%;
            left: 50%;
            transform: translate(-50%, 0%);
            width: 40px;
            height: 2px;
            background: #0ebcf2;
            margin: 0 auto;
          }

          // &:hover {
          // }
        }
      }
      .nav-list {
        margin-left: 86px;
        width: 110px;
        height: 78px;
        display: none;
        img {
          display: block;
          width: 110px;
          height: 78px;
        }
      }
      .nav-img {
        margin-right: 363px;
        img {
          cursor: pointer;
          width: 41px;
          height: 58px;
        }
      }
    }
    .header-left {
      margin-top: 251px;
      .header-left-title {
        width: 630px;
        font-size: 70px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #ffffff;
      }
      .header-left-mes {
        margin-top: 47px;
        font-size: 30px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #ffffff;
      }
    }
    .header-right {
      width: 637px;
      height: 506px;
      margin-top: 157px;
      img {
        display: block;
        width: 637px;
        height: 506px;
      }
    }
  }
  .cover {
    overflow: hidden;
    width: 1200px;
    height: 531px;
    box-shadow: 0px 6px 24px 0px rgba(120, 120, 120, 0.46);
    border-radius: 25px;
    background: url(../../assets/images/home/cover/mes.png) no-repeat;
    background-size: 100%;
    margin: 0 auto;
    margin-top: -100px;
    p {
      text-align: center;
      font-size: 40px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      color: #333333;
      margin-top: 144px;
    }
    .mes {
      width: 754px;
      font-size: 20px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #333333;
      line-height: 36px;
      text-align: center;
      margin: 0 auto;
      margin-top: 74px;
    }
  }
  .main {
    overflow: hidden;
    height: 2230px;
    .title {
      font-size: 40px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      color: #333333;
      text-align: center;
      margin-top: 115px;
      margin-bottom: 68px;
    }
    .main-one-a {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 1200px;
      height: 422px;
      margin: 0 auto;
      margin-top: 73px;

      .one-a-left {
        .one-line {
          width: 132px;
          height: 9px;
          background: #16387e;
        }
        .one-name {
          font-size: 36px;
          font-family: Source Han Sans CN;
          font-weight: 500;
          color: #333333;
          margin-top: 29px;
        }
        .one-mes {
          width: 626px;
          font-size: 20px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #666666;
          line-height: 48px;
          margin-top: 55px;
        }
      }
      .one-a-right {
        img {
          width: 422px;
          height: 422px;
        }
      }
    }

    .main-one-b {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 1200px;
      height: 422px;
      margin: 0 auto;
      margin-top: 73px;
      .one-b-left {
        img {
          width: 422px;
          height: 422px;
        }
      }
      .one-b-right {
        .one-line {
          width: 132px;
          height: 9px;
          background: #16387e;
        }
        .one-name {
          font-size: 36px;
          font-family: Source Han Sans CN;
          font-weight: 500;
          color: #333333;
          margin-top: 29px;
        }
        .one-mes {
          width: 626px;
          font-size: 20px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #666666;
          line-height: 48px;
          margin-top: 55px;
        }
      }
    }
  }
  .bottom-top {
    overflow: hidden;
    width: 1920px;
    height: 800px;
    background: url(../../assets/images/home/bottomtop/bpttom-top-bg.jpg)
      no-repeat;
    background-size: 100%;
    .title {
      margin-top: 82px;
      font-size: 40px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      color: #ffffff;
      text-align: center;
      margin-bottom: 74px;
    }
    .mes {
      width: 1200px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 0 auto;
      .mes-left {
        .mes-line {
          width: 110px;
          height: 9px;
          background: #fdfcf7;
        }
        .mes-mes {
          width: 480px;
          font-size: 20px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #ffffff;
          line-height: 48px;
          margin-top: 42px;
        }
      }
      .mes-right {
        width: 715px;
        height: 584px;
        img {
          width: 715px;
          height: 584px;
        }
      }
    }
  }
  .bottom-bank {
    width: 1920px;
    height: 836px;
    background: url(../../assets/images/home/bottom/we-bank.jpg) no-repeat;
    background-size: 100%;
    overflow: hidden;
    .title {
      font-size: 40px;
      font-family: Source Han Sans CN;
      font-weight: 200;
      color: #333333;
      text-align: center;
      margin-top: 116px;
      margin-bottom: 93px;
    }
    //   .bottom-img {
    //     // img {
    //     // }
    //   }
  }
  .bottom-bot {
    display: flex;
    justify-content: center;
    align-items: flex-start;
    width: 1920px;
    height: 650px;
    background: url(../../assets/images/home/bottom/bottom-bg.jpg) no-repeat;
    background-size: 100%;
    .bot-left {
      margin-top: 125px;
      .bot-title {
        font-size: 40px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        color: #ffffff;
      }
      .bot-mes {
        font-size: 40px;
        font-family: Source Han Sans CN;
        font-weight: 200;
        color: #ffffff;
        margin-top: 31px;
      }
      .bot-box {
        margin-top: 95px;
        .box-one {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          margin-bottom: 20px;
          img {
            width: 24px;
            height: 22px;
          }
          p {
            margin-left: 13px;
            font-size: 20px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #ffffff;
          }
        }
      }
    }
    .bot-right {
      margin-left: 423px;
      margin-top: 329px;
      img {
        width: 136px;
        height: 136px;
      }
      p {
        width: 146px;
        font-size: 18px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #ffffff;
        line-height: 48px;
        letter-spacing: 16px;
        text-align: center;
      }
    }
  }
  .bottom-end {
    width: 1920px;
    height: 75px;
    background: #1c1c1c;
    text-align: center;
    line-height: 75px;
    font-size: 12px;
    font-family: Myriad Pro;
    font-weight: 400;
    color: #ffffff;
  }
}
</style>
